/*
 * File: /src/router/routes/connectorMap.js
 * Created Date: Thursday April 7th 2022
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 7th April 2022 10:10:30 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2022 AdBase, Inc.
 */

const ConnectorMapList = () =>
  import(
    /* webpackChunkName: "Connector" */ 'src/components/Dashboard/Views/Connector/ConnectorMapList.vue'
  );

export const connectorMapRoutes = [
  {
    path: 'connector-map/list',
    name: 'Connector Map List',
    component: ConnectorMapList,
  },
];
